import {useI18n} from '@yandex-delivery/core/i18n'
import {useMemo} from 'react'

import {useConfigContext} from '../../../../../contexts'
import fallbackSrc from '../assets/bg.svg'
import type {BusinessModalProps} from '../BusinessModal@mobile'

export function useBusinessBannerModal(props: BusinessModalProps) {
  const i18n = useI18n()
  const config = useConfigContext()
  const description = i18n(
    'bdui.banner.description.default',
    'Несколько минут на регистрацию — и у вас будет эта и другие возможности Доставки для бизнеса:',
  )
  const list = i18n(
    'bdui.banner.list.default',
    'оплата с расчётного счёта\nдоставка негабаритных вещей\nспециальные функции и тарифы.',
  )
  const imageSrc = fallbackSrc
  const title = i18n(
    'bdui.banner.title.payment-contract',
    'Оплата с расчётного счёта доступна только в личном кабинете для бизнеса',
  )

  const queryParams: Record<string, string> = useMemo(() => {
    return {offer: 'true'}
  }, [])

  if (props.utmSource) {
    queryParams.utm_source = props.utmSource
  }

  return useMemo(() => {
    return {
      opened: props.opened,
      onClose: props.onClose,
      title,
      description,
      list: list.split('\n').filter(Boolean),
      imageSrc,
      link: config.getRegistrationUrl(queryParams),
    } as const
  }, [config, description, imageSrc, list, props.onClose, props.opened, queryParams, title])
}
